<script lang="ts">
  import { Cancellation, cancellationTotal } from "@models/cancellations/Cancellation"
  import { Person } from "@models/profiles/Person"
  import { formatCentsAsUsd } from "@util/money"

  export let cancellation: Cancellation
  export let person: Person
</script>

<div class="grid grid-cols-3 gap-block-4 mt-1" data-role="payment-breakdown">
  <div class="col-span-2" data-role="description">Net Payments</div>

  <div class="text-right" data-role="amount">
    {formatCentsAsUsd(cancellation.netPaid)}
  </div>
</div>

{#if cancellation.totalAchDiscounts !== 0}
  <div class="grid grid-cols-3 gap-block-4" data-role="payment-breakdown">
    <div class="col-span-2" data-role="description">ACH Discounts</div>

    <div class="text-right" data-role="amount">
      {formatCentsAsUsd(cancellation.totalAchDiscounts)}
    </div>
  </div>
{/if}

{#if cancellation.totalConvenienceFeesFromPayments !== 0}
  <div class="grid grid-cols-3 gap-block-4" data-role="payment-breakdown">
    <div class="col-span-2" data-role="description">Convenience Fees</div>

    <div class="text-right" data-role="amount">
      {formatCentsAsUsd(cancellation.totalConvenienceFeesFromPayments)}
    </div>
  </div>
{/if}

{#if cancellation.totalAffirmFeesFromPayments !== 0}
  <div class="grid grid-cols-3 gap-block-4" data-role="payment-breakdown">
    <div class="col-span-2" data-role="description">Affirm Fees collected by customer</div>

    <div class="text-right" data-role="amount">
      {formatCentsAsUsd(cancellation.totalAffirmFeesFromPayments)}
    </div>
  </div>
{/if}

<div class="grid grid-cols-3 gap-block-4" data-role="payment-breakdown">
  <div class="col-span-2 text-gray-900 font-bold" data-role="description">Total Paid for {person.firstName}</div>

  <div class="text-right text-gray-900 font-bold" data-role="amount">
    {formatCentsAsUsd(cancellationTotal(cancellation))}
  </div>
</div>
